import React from 'react';
import {PageIndex} from "./pages/PageIndex";
import {Footer} from "./component/context/Footer";

function App() {
  return <>
      <div className={"bg-page text-main clay-text-shadow"}>
          <div className={"min-h-screen pb-4 content-padding"}>
              <PageIndex />
          </div>
          <Footer />
      </div>
  </>;
}

export default App;
